/** PostHog flag that turns Vipps Hurtigkasse on. Must exist in every PostHog project. */
export const VIPPS_HURTIGKASSE_FLAG = "vipps-hurtigkasse";

/** What the customer shares from the app: name, email, phone and address for the order. */
export const VIPPS_PROFILE_SCOPE = "name email phoneNumber address";

/** The payment metadata key that lets the payment service find the cart from a Vipps event. */
export const VIPPS_METADATA_KEY_CART_ID = "cartId";
